import { ArrowDownIcon, ArrowUpIcon, Box, keychaine } from '@chaine/keychaine';
import React, { useState } from 'react';
import { Marker as ReactMapGLMarker } from 'react-map-gl';
import { StopMarkerPopup } from './stop-marker-popup';
const StopMarker = (props) => {
    const { index, preventPopupsOnHover = false, stop } = props;
    const [isHovered, setIsHovered] = useState(false);
    const coordinates = stop?.warehouse?.address?.coordinates;
    const handleMouseEnter = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);
    const onHandleMouseEnter = (event) => {
        event.preventDefault();
        handleMouseEnter();
    };
    const onHandleMouseLeave = (event) => {
        event.preventDefault();
        handleMouseLeave();
    };
    return (React.createElement(React.Fragment, null,
        isHovered && !preventPopupsOnHover && (React.createElement(Box, { sx: {
                '.mapboxgl-popup-content': {
                    borderRadius: '12px',
                    borderWidth: '1px',
                    borderColor: '#21262d',
                    background: '#21262d',
                    '-webkit-backdrop-filter': 'blur(10px)',
                    'backdrop-filter': 'blur(10px)'
                }
            } },
            React.createElement(StopMarkerPopup, { stop: stop }))),
        React.createElement(ReactMapGLMarker, { key: `${index}-${stop.id}-marker`, latitude: coordinates?.latitude || 0, longitude: coordinates?.longitude || 0 },
            React.createElement(keychaine.span, { onMouseEnter: onHandleMouseEnter, onMouseLeave: onHandleMouseLeave },
                React.createElement(Box, { "aria-label": "stop-marker", width: 5, height: 5, borderRadius: stop.type === 'Pick' ? 12 : 4, backgroundColor: "black", color: 'white', display: "flex", alignItems: "center", justifyContent: 'center' }, index == 0 ? stop.type === 'Pick' ? React.createElement(ArrowUpIcon, null) : React.createElement(ArrowDownIcon, null) : index + 1)))));
};
const StopsMarkers = (props) => {
    const { stops, preventPopupsOnHover = false } = props;
    return (React.createElement(Box, null, (stops || []).map((item, index) => {
        const coordinates = item?.warehouse?.address?.coordinates;
        if (!coordinates?.latitude || !coordinates?.longitude) {
            return React.createElement(keychaine.span, { key: item.id });
        }
        return React.createElement(StopMarker, { preventPopupsOnHover: preventPopupsOnHover, index: index, key: item.id, stop: item });
    })));
};
StopsMarkers.displayName = 'StopsMarker';
export { StopsMarkers };
